"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultGlobalSettings = void 0;
exports.defaultGlobalSettings = {
    dimApiEnabled: true,
    destinyProfileMinimumRefreshInterval: 15,
    destinyProfileRefreshInterval: 30,
    autoRefresh: true,
    refreshProfileOnVisible: true,
    bustProfileCacheOnHardRefresh: false,
    dimProfileMinimumRefreshInterval: 300,
    showIssueBanner: false,
};
